import { BuildingOfficeIcon } from "@heroicons/react/20/solid";
import ArrowDownOnSquareStackIcon from "@heroicons/react/24/outline/ArrowDownOnSquareStackIcon";
import {
  ChartBarSquareIcon,
  ChartPieIcon,
  CheckCircleIcon,
  GlobeAltIcon,
  ServerStackIcon,
  UserIcon,
  UsersIcon,
} from "@heroicons/react/24/solid";
import { mdiTunnelOutline } from "@mdi/js";
import Icon from "@mdi/react";
import React, { FC, ReactElement } from "react";
import {
  Activity,
  AlertTriangle,
  AlignJustify,
  Aperture,
  Archive,
  Clock,
  Copy,
  Edit,
  Edit2,
  Eye,
  EyeOff,
  Filter,
  HelpCircle,
  Home,
  List,
  Maximize2,
  Menu,
  MinusCircle,
  PlusCircle,
  RefreshCw,
  Repeat,
  RotateCcw,
  Search,
  Settings,
  Trash,
  Upload,
  User,
  Users,
  XCircle,
} from "react-feather";

import { Error, Launch, ShuffleOutlined } from "@mui/icons-material";
import { HourglassEmpty } from "@mui/icons-material";
import CloudSyncIcon from "@mui/icons-material/CloudSyncOutlined";
import DnsIcon from "@mui/icons-material/Dns";
import FolderIcon from "@mui/icons-material/Folder";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import GavelIcon from "@mui/icons-material/Gavel";
import HistoryIcon from "@mui/icons-material/History";
import HttpIcon from "@mui/icons-material/Http";
import HttpsIcon from "@mui/icons-material/Https";
import OpenInNew from "@mui/icons-material/OpenInNew";
import SettingsIcon from "@mui/icons-material/Settings";
import { SvgIconProps } from "@mui/material/SvgIcon";

import Pomerium from "../icons/Pomerium";
import MCP from "../icons/mcp";
import SvgIcon from "./styled/SvgIcon";

export const ArchiveIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Archive />
  </SvgIcon>
);
export const AlertTriangleIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <AlertTriangle />
  </SvgIcon>
);
export const BackIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <RotateCcw />
  </SvgIcon>
);
export const CertificateIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <UserIcon />
  </SvgIcon>
);
export const ChangesetIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <ArrowDownOnSquareStackIcon />
  </SvgIcon>
);

export const ChangesetAppliedIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <CheckCircleIcon />
  </SvgIcon>
);
export const CircleMinus = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <MinusCircle />
  </SvgIcon>
);
export const CirclePlus = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <PlusCircle />
  </SvgIcon>
);
export const CircleX = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <XCircle />
  </SvgIcon>
);
export const ClockIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Clock />
  </SvgIcon>
);
export const CookieIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Aperture />
  </SvgIcon>
);
export const DeleteIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Trash />
  </SvgIcon>
);
export const DeploymentHistoryIcon = (props: SvgIconProps): ReactElement => (
  <HistoryIcon {...props} />
);
export const DNSIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <DnsIcon />
  </SvgIcon>
);
export const EditIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon color="primary" {...props}>
    <Edit />
  </SvgIcon>
);
export const ViewIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Eye />
  </SvgIcon>
);
export const NoViewIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <EyeOff />
  </SvgIcon>
);
export const ExternalDataSourceIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <CloudSyncIcon />
  </SvgIcon>
);
export const FilterListIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Filter />
  </SvgIcon>
);
export const FilledFolderIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <FolderIcon />
  </SvgIcon>
);
export const FilledSettingsIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <SettingsIcon />
  </SvgIcon>
);
export const HourglassEmptyIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <HourglassEmpty />
  </SvgIcon>
);
export const HeadersIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <AlignJustify />
  </SvgIcon>
);
export const HTTPIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <HttpIcon />
  </SvgIcon>
);
export const HTTPSIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <HttpsIcon />
  </SvgIcon>
);
export const ImpersonateIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Users />
  </SvgIcon>
);
export const InfoPageIcon = (props: SvgIconProps): ReactElement => (
  <FormatListBulletedOutlinedIcon {...props} />
);

export const LaunchIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Launch />
  </SvgIcon>
);

export const LogsIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <List />
  </SvgIcon>
);

export const HomeIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Home />
  </SvgIcon>
);

export const GlobalIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <GlobeAltIcon />
  </SvgIcon>
);

export const ClusterIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <ServerStackIcon />
  </SvgIcon>
);

export const ActivityIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Activity />
  </SvgIcon>
);

export const LoadBalancerIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <ShuffleOutlined />
  </SvgIcon>
);

export const ErrorIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Error />
  </SvgIcon>
);
export const MaxIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Maximize2 />
  </SvgIcon>
);
export const MCPIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <MCP />
  </SvgIcon>
);
export const MenuIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Menu />
  </SvgIcon>
);
export const MoveIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Copy />
  </SvgIcon>
);
export const NamespaceIcon = (props: SvgIconProps): ReactElement => (
  <FolderOutlinedIcon {...props} />
);
export const PencilIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Edit2 />
  </SvgIcon>
);
export const PersonIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <User />
  </SvgIcon>
);
export const PolicyIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <GavelIcon />
  </SvgIcon>
);
export const PomeriumIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Pomerium />
  </SvgIcon>
);
export const QuestionMarkCircle = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <HelpCircle />
  </SvgIcon>
);
export const RefreshIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <RefreshCw />
  </SvgIcon>
);
export const RouteIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <ChartPieIcon />
  </SvgIcon>
);
export const RuntimeIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <ChartPieIcon />
  </SvgIcon>
);
export const SearchIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Search />
  </SvgIcon>
);

export const SessionIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <UsersIcon />
  </SvgIcon>
);
export const OpenInNewIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <OpenInNew />
  </SvgIcon>
);
export const OutlinedSettingsIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Settings />
  </SvgIcon>
);
export const UploadIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Upload />
  </SvgIcon>
);

export const TrafficIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <ChartBarSquareIcon />
  </SvgIcon>
);

export const RotateIcon = (props: SvgIconProps): ReactElement => (
  <SvgIcon {...props}>
    <Repeat />
  </SvgIcon>
);

export const OrganizationIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon {...props}>
    <BuildingOfficeIcon />
  </SvgIcon>
);

export const UpstreamTunnelIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <Icon path={mdiTunnelOutline} size={1} />
  </SvgIcon>
);
